module.exports = __webpack_public_path__ + "static/wireframe-online-banking-app-web-plp-52d093d34871d83285fe54969254c2ce.png";